import React from 'react';
import Modal from '../../../shared/components/ui/Modal';
import Button from '../../../shared/components/ui/Button';

/**
 * Confirm step for deleting a management task or subtask. A delete cannot be
 * undone, so `detail` says what goes with it.
 */
const ConfirmDeleteModal = ({ title, name, detail, busy, onConfirm, onClose }) => (
    <Modal name={title} width={40} onClose={busy ? () => {} : onClose} hideClose={busy}>
        <div className="space-y-3">
            <p className="text-base text-gray-800">
                Delete <span className="font-semibold">&lsquo;{name || 'this item'}&rsquo;</span>?
            </p>
            {detail && <p className="text-sm text-gray-600">{detail}</p>}
            <p className="text-sm font-medium text-[#B42318]">This cannot be undone.</p>
        </div>
        <div className="w-full flex justify-end items-center space-x-4 mt-8">
            <Button type="button" onClick={onClose} displayType="secondary" disabled={busy}>
                Cancel
            </Button>
            <Button type="button" onClick={onConfirm} displayType="primary-red" disabled={busy}>
                {busy ? 'Deleting...' : 'Delete'}
            </Button>
        </div>
    </Modal>
);

export default ConfirmDeleteModal;
